import axios from "axios";

import { getTeams } from "./teams_service";
import { getDocumentById } from "services/documents_service";
import { getAccount } from "services/account_service";

export const login = async (username, password) => {
  let resp = await axios.post(
    process.env.REACT_APP_BACKEND_URL + "api/auth/local",
    {
      identifier: username,
      password: password,
    }
  );

  //TODO: ADD VALIDATIONS FOR ERRORS CASE THESE ITEMS ARE NOT DEFINED.
  localStorage.setItem("jwt", resp.data.jwt);
  localStorage.setItem("userId", resp.data.user.id);
  localStorage.setItem("blocked", resp.data.user.blocked);
  localStorage.setItem("username", resp.data.user.username);

  localStorage.setItem(
    "taxpayer_number",
    resp.data.user.accounts[0].taxpayer_number
      ? resp.data.user.accounts[0].taxpayer_number
      : ""
      );
  localStorage.setItem("accountId", resp.data.user.accounts[0].id);
  await updateLocalStorageAccInfo();
};

export const updateLocalStorageAccInfo = async () => {
  let account = await getAccount(localStorage.getItem("accountId"));
  
  localStorage.setItem(
    "taxpayer_number",
    account.attributes.taxpayer_number
      ? account.attributes.taxpayer_number
      : ""
  );
  localStorage.setItem("accountName", account.attributes.name);
  localStorage.setItem("shirtNumber", account.attributes.shirt_number ? account.attributes.shirt_number : "" );
  localStorage.setItem("role", account.attributes.role);
  localStorage.setItem("sub_role", account.attributes.sub_role);
  localStorage.setItem("accountId", account.id);

  if (account.attributes.age) {
    localStorage.setItem("age", account.attributes.age);
  }
  if (account.attributes.height) {
    localStorage.setItem("height", "" + account.attributes.height);
  }
  if (
    account.attributes.position &&
    account.attributes.position.length
  ) {
    localStorage.setItem(
      "position",
      JSON.stringify(account.attributes.position)
    );
  }
  if (account.attributes.stadium) {
    localStorage.setItem("stadium", account.attributes.stadium);
  }
  if (account.attributes.foundation_year) {
    localStorage.setItem(
      "foundation_year",
      account.attributes.foundation_year
    );
  }
  if (account.attributes.site) {
    localStorage.setItem("site", account.attributes.site);
  }
  if (account.attributes.locality) {
    localStorage.setItem("locality", account.attributes.locality);
  }
  if (account.attributes.phone_number) {
    localStorage.setItem("phone_number", account.attributes.phone_number);
  }
  if (account.attributes.president_name) {
    localStorage.setItem(
      "president_name",
      account.attributes.president_name
    );
  }
  if (account.attributes.phone_number) {
    localStorage.setItem(
      "phone_number",
      account.attributes.phone_number
    );
  }
  if (account.attributes.date_of_birth) {
    localStorage.setItem(
      "date_of_birth",
      account.attributes.date_of_birth
    );
  }

  let teams = await getTeams();
  localStorage.setItem(
    "teamIDs",
    JSON.stringify(
      teams.map((el) => {
        return {
          id: el.id,
          label: el.attributes.name,
        };
      })
    )
  );

  if (teams && teams.length > 0) {
    let clubAcc = teams[0].attributes.accounts.data.find(
      (el) => el.attributes.role === "Clube"
    );
    if (!clubAcc) return;
    const acc = await getAccount(clubAcc.id);
    if (!acc.attributes?.logo?.data?.id) return;
    let document = await getDocumentById(acc.attributes.logo.data.id);
    if (document.attributes?.body?.data?.attributes?.url) {
      localStorage.setItem(
        "clube_logo",
        document.attributes.body.data.attributes.url
      );
    }
  }

};

export const getAuthorizationHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("jwt")}`,
    },
  };
};

export const logout = () => {
  localStorage.clear();
};

export const isLoggedIn = () => {
  return !!localStorage.getItem("jwt");
};

export const hasTaxpayerNumb = () => {
  return (
    localStorage.getItem("taxpayer_number") &&
    localStorage.getItem("taxpayer_number") !== ""
  );
};

export const registerAccount = async (obj) => {
  console.log("🚀 ~ file: auth_service.js:87 ~ registerAccount ~ obj:", obj);
  return await axios.post(
    process.env.REACT_APP_BACKEND_URL + "api/sign-up",
    obj
  );
};

export const changePass = async (newPass, token) => {
  const res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/auth/reset-password?code=${token}`,
    { code: token, password: newPass, passwordConfirmation: newPass }
  );

  return res;
};

export const changePassLoggedIn = async (password, repeatpass, oldPass) => {
  const res = await axios.post(
    process.env.REACT_APP_BACKEND_URL + `api/auth/change-password`,
    {
      currentPassword: oldPass,
      password: password,
      passwordConfirmation: repeatpass,
    },
    getAuthorizationHeader()
  );

  return res;
};

export const recoverPass = async (email) => {
  return await axios.post(
    process.env.REACT_APP_BACKEND_URL + "api/auth/forgot-password",
    {
      email: email,
    }
  );
};
